import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isRecurring, userType } = {}) => ({
    bar: {
      position: 'sticky',
      top: '80px',
      boxSizing: 'border-box',
      zIndex: 100,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingTop: '20px',
      paddingBottom: theme.spacing(1),
      margin: '0 auto',
      backgroundColor: 'white',
      maxWidth: 1180,
      [theme.breakpoints.down('xl')]: {
        top: '70px',
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: 0,
        top: '53px',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          top: '40px',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          paddingBottom: 0,
        }),
      },
    },
    desktopSearch: {
      alignSelf: 'flex-start',
      marginTop: theme.spacing(2.5),
    },
    pageHeader: {
      fontSize: '28px',
      lineHeight: '38px',
      letterSpacing: '-0.4px',
      fontWeight: 700,
      marginBlock: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        fontSize: '22px',
        marginBlock: 0,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: '22px',
          marginBlock: 0,
        }),
      },
    },
    panel: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginInline: 'auto',
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          justifyContent: 'center',
        }),
      },
    },
    tabs: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: isRecurring ? theme.spacing(1) : theme.spacing(3),
    },
    tab: {
      textTransform: 'none',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      paddingInline: theme.spacing(4),
      paddingBottom: 0,
      borderBottom: `2px solid ${theme.palette.grey1}`,
      color: theme.palette.grey1,
      '&.Mui-selected': {
        color:
          userType === 'kite' ? theme.palette.primary2 : theme.palette.primary1,
      },
    },
    results: {
      color: '#54565B',
      fontSize: 16,
      fontWeight: 600,
    },
  }),
);
